import { Children } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  children: React.ReactNode;
};

const Breadcrumb: React.FC<Props> = ({ children, className }) => {
  return (
    <nav className={classNames('max-w-full overflow-x-auto scrollbar-hide', className)} aria-label="Breadcrumb">
      <ol
        role="list"
        className="flex items-center justify-start gap-x-1 gap-y-[22px] whitespace-pre text-[12px] text-neutrals-black-50"
      >
        {Children.map(children, (Child, index) => (
          <>
            <li>{Child}</li>
            <li>{index < Children.count(children) - 1 && <span>/</span>}</li>
          </>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
